var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TextInput"},[_c('div',{staticClass:"main-input"},[_c('div',{staticClass:"input-z",style:({backgroundColor: _vm.color, border: `1px dashed ${_vm.color}`})},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"input-y",style:({border: `0.04rem dashed ${_vm.color}`})},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }